<template lang="pug">
svg(
  viewBox="0 0 42 40"
  xmlns="http://www.w3.org/2000/svg"
  :x="x"
  :y="y"
  :width="width"
  :height="height"
  fill="none"
)
  ellipse(
    transform="rotate(-90 20 20)"
    cx="20"
    cy="21"
    rx="18"
    ry="19"
    :stroke="lineColor"
    stroke-width="3"
    stroke-linecap="round"
    :stroke-dasharray="pathLength"
    :stroke-dashoffset="strokeDashoffset"
  )
</template>

<script setup lang="ts">
interface ProgressRoundedProps {
  /**
   * Line color of the progress indicator
   */
  lineColor: string;
  /**
   * X position of the progress indicator
   */
  x: number;
  /**
   * Y position of the progress indicator
   */
  y: number;
  /**
   * Width of the progress indicator
   */
  width: number;
  /**
   * Height of the progress indicator
   */
  height: number;
  /**
   * Percentage of the progress indicator
   */
  progress: number;
}

const props = defineProps<ProgressRoundedProps>();
const strokeDashoffset = ref('0');

// Value obtained from a mounted version of the component
const pathLength = 115.5111083984375;

const offset = computed(() => pathLength - (props.progress / 100) * pathLength);
watchImmediate(offset, newOffset => {
  strokeDashoffset.value = newOffset >= 0 ? String(newOffset) : '100';
});
</script>
